module.exports = __webpack_public_path__ + "static/media/level_icon.423eaad8.svg";